import isIframe from './isIframe'
import forceUpdateUrl from './forceUpdateUrl'



const PRODUCT_TYPE_DP = 'depositPhotos'
const isIcons8Page = window._isIcons8Page_


export const prepareSearchResponseProducts = (products) => {
  if (!products) {
    return products
  }

  // TODO: need to replace to assertions
  if (!Array.isArray(products)) {
    console.error(`Products field has incorrect type. An array is expected, but ${typeof products} given`)

    return products
  }

  return products.map(({ downloads, ...product }) => {
    if (isIframe()) {
      product.publicURL = forceUpdateUrl(product.publicURL)

      // Updated the thumbnail url with session token for Lectora
      if (isIcons8Page) {
        product.thumbnailURL = forceUpdateUrl(product.thumbnailURL)
      }
    }

    product.isPremium = product.type === PRODUCT_TYPE_DP && !product.isFreeItem

    if (!downloads) {
      return product
    }

    // TODO: need to replace to assertions
    if (!Array.isArray(downloads)) {
      console.error(`Downloads field has incorrect type. An array is expected, but ${typeof downloads} given`)

      return product
    }

    return {
      ...product,
      downloads: downloads.map((download) => updateProductDownload(download, product.id)),
    }
  })
}

function updateProductDownload (item, productID) {
  if (!item) {
    throw new Error('Download item is required')
  }

  const formattedSize = item.filesize ? sizeFormat(item.filesize) : ''
  const extension = makeExtension(item.filename)

  let textDescription = `${item.description || ''}, ${extension}`

  const videoStockDescription = 'Video File'

  if (item.description === videoStockDescription) {
    textDescription = item.format ? `${item.format} ${videoStockDescription}` : videoStockDescription
  }

  let computedDownloadURL

  // Updated download URL for icons8
  if (item.type && item.type === 'icons8') {
    computedDownloadURL = `/product/download/${productID}?extension=${extension}&type=${item.type}`
  } else {
    computedDownloadURL = item.downloadURL || `/product/download/${productID}?chunkID=${item.id}&option=${item.option}`
  }

  if (isIframe()) {
    computedDownloadURL = forceUpdateUrl(computedDownloadURL)
  }

  return {
    ...item,
    computedDescription: `${textDescription}, ${formattedSize}`,
    computedDownloadURL,
  }
}

function makeExtension (filename) {
  const namePartitions = filename.split('.')

  if (namePartitions.length > 1) {
    return namePartitions.pop()
  }

  return namePartitions[0]
}

function sizeFormat (bytes) {
  if (!bytes) {
    return '0 B'
  }

  const base = 1024
  const accuracyLevel = 1

  const mbSize = bytes / (base ** 2)
  const kbSize = bytes / base

  return (mbSize >= 0.1)
    ? `${mbSize.toFixed(accuracyLevel)} MB`
    : `${kbSize.toFixed(accuracyLevel)} KB`
}
